<template>
  <div class="main">
    <div class="side-bar">
      <media
        :query="{maxWidth: 1152}"
      >
        <side-bar :isWide="false" />
      </media>
      <media
        :query="{minWidth: 1152}"
        @media-enter="setWide(true)"
        @media-leave="setWide(false)"
      >
        <side-bar :isWide="true" />
      </media>
    </div>
    <div
      class="main-contents"
      :class="{wide: isWide}"
    >
      <user-info />
      <section class="section">
        <common-header
          v-if="displayTitle"
          :title="title"
          :subTitle="subTitle"
        >
          <template slot="rightElements">
            <slot name="rightElements" />
          </template>
        </common-header>
        <slot name="content" />
      </section>
      <footer class="footer">
        <div class="content has-text-centered">
          <p>
            © 2019 Virtusize
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import Media from 'vue-media'
import CommonHeader from '@/components/common/CommonHeader'
import SideBar from '@/components/common/SideBar'
import UserInfo from '@/components/common/UserInfo'
export default {
  components: {
    Media,
    SideBar,
    UserInfo,
    CommonHeader
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      default: ''
    },
    displayTitle: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isWide: window.innerWidth > 1152
    }
  },
  methods: {
    setWide (isWide) {
      this.isWide = isWide
    }
  }
}
</script>
<style lang="scss" scoped>
.main {
  min-height: 100vh;

  .side-bar {
    position: fixed;
    height: 100%;
  }

  .main-contents {
    width: 100%;
    padding-left: 130px;

    .section {
      padding-top: 90px;
      padding-right: 78px;
    }

    &.wide {
      padding-left: 220px;
    }
  }

  .footer {
    padding: 30px 0;
    color: #575757;
    font-size: 13px;
    background-color: transparent;
  }
}
</style>
